export const getEventDetail = (item) => ({
    item,
    text: item.text,
    href: item.href,
});
//# sourceMappingURL=utils.js.map